import actionTypes from 'dashboard/actions/announcements/action-types';
import { addAnnouncement, deleteAnnouncement, getArchivedAnnouncements } from 'dashboard/reducers/announcements/utils';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_ANNOUNCEMENTS_SUCCESS:
      return getArchivedAnnouncements([...action.items], action.lotteryTime, action.locale);
    case actionTypes.DELETE_ARCHIVED_ANNOUNCEMENT:
      return deleteAnnouncement([...state], action.index);
    case actionTypes.ADD_ARCHIVED_ANNOUNCEMENT:
      return addAnnouncement([...state], action.announcement, action.locale);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/announcements/archived.js